import React from 'react';
import { Link } from "react-router-dom";
import logo1 from "../src/Assets/Logo1.png"; 
import "./Navbar.css";

function Navbar() {
  const closeMenu = () => {
    console.log("Menu closed");
  };

  return (
    <nav className='nav-main'>
      <div className="nav-left">
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo1} alt="Logo" style={{ cursor: "pointer" }} />
          </Link>
        </div>
      </div>

      <div className="nav-right">
        <ul className="nav-links">
          <li><Link to="/" onClick={closeMenu}>Services</Link></li>
          <li><Link to="/products" onClick={closeMenu}>Products</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
